var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pre"},[_c('img',{attrs:{"src":_vm.cdnresources + '/prod/images/xiangaibao/gongs.png'}})])}
var staticRenderFns = []

export { render, staticRenderFns }